import React, { FC } from 'react';
import { AriaSort } from './model/OrdemColunaTabela';
import { AiOutlineSortAscending, AiOutlineSortDescending } from 'react-icons/ai';
import styled from 'styled-components';


interface OrdemColunaIconeProps extends React.HTMLAttributes<any> {
  ariaSort: AriaSort;
}

export const OrdemColunaIcone: FC<OrdemColunaIconeProps> = ({ariaSort, ...props}) => {
  
  if (ariaSort === 'ascending') {
    return <Icone as={AiOutlineSortAscending} {...props} />
  } else if (ariaSort === 'descending') {
    return <Icone as={AiOutlineSortDescending} {...props} />
  } else {
    return <></>;
  }
}

const Icone = styled.div`
  font-size: 1.3em;
`;